import { IconCheck, IconCopy } from '@tabler/icons-react';
import { formatReferralCode } from '../../utils/referral';
import './ReferralCodeChip.scss';

export default function ReferralCodeChip({
    code,
    copied = false,
    onCopy,
    readonly = false,
}) {
    const displayCode = formatReferralCode(code);

    const handleCopy = () => {
        if (!readonly && onCopy) {
            onCopy();
        }
    };

    return (
        <div className={`referral-code-chip${readonly ? ' referral-code-chip--readonly' : ''}`}>
            <button
                type="button"
                className="referral-code-chip__value"
                onClick={handleCopy}
                disabled={readonly}
                aria-label={readonly ? `Код друга: ${displayCode}` : `Скопировать код ${displayCode}`}
            >
                {displayCode}
            </button>
            {!readonly && (
                <button
                    type="button"
                    className={`referral-code-chip__action${copied ? ' referral-code-chip__action--success' : ''}`}
                    onClick={handleCopy}
                    aria-label={copied ? 'Скопировано' : 'Копировать код'}
                >
                    {copied ? <IconCheck size={18} stroke={1.5} /> : <IconCopy size={18} stroke={1.5} />}
                </button>
            )}
        </div>
    );
}
